import React, { useContext } from 'react';
import StatusLabel from '../../../VentoryUI/components/common/StatusLabel/StatusLabel';
import { ProductTransactionStatusContext } from '../../../context/ProductTransactionStatusContext';
import { translate } from '../../../types/translation/Translator';
import { TranslationKey } from '../../../types/translation/TranslationKey';
import { ColorUtil } from '../../../util/color.util';

interface ProductTransactionStatusLabelProps {
  statusId: string;
}

export default function ProductTransactionStatusLabel({ statusId }: ProductTransactionStatusLabelProps) {
  const { productTransactionStatuses } = useContext(ProductTransactionStatusContext);

  const status = productTransactionStatuses.get(statusId);
  if (!status) return null;

  const text = translate({ key: (status.name.toLowerCase() || status) as TranslationKey });
  const color = { color: status.color, backgroundColor: ColorUtil.lightBackground(status.color) };

  return <StatusLabel color={color} text={text} />;
}
